<template lang="pug">
  r-table(
    loading-text="Cargando facturas en detalle..."
    no-data-text="Sin facturas en detalle."
    no-actions
    no-search
    no-remove
    ref="table"
    v-bind="tableProps"
    @detail="submitShow"
    )
    //dialog-invoice-detail(
      :invoice-id="invoiceId"
      ref="dialog"
      )
</template>

<script>
  //
  import { RTable } from '@/components/reusable_components/next'
  //
  import ProviderDebtToPayPendingService from '@/services/api/purchase/PchProviderDebtToPayPending'
  import ProviderDebtToPayPendingHeaders from '@/views/Purchase/PchProviderDebtToPayPending/PchProviderDebtToPayPendingHeaders'
  //
  export default {
    name: 'purchase-invoice-detail-provider',
    components: {
      RTable,
    },
    computed: {

      /**
       * { function_description }
       *
       * @return     {Object}  { description_of_the_return_value }
       */
      tableProps() {
        return {
          service: new ProviderDebtToPayPendingService().toList(),
          headers: ProviderDebtToPayPendingHeaders,
          filters: [],
          paramFilter: {
            pch_provider_id: this.$route.params.id,
          },
        }
      },
    },
    data() {
      return {
        selected: null,
      }
    },
  }
</script>
